import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/images/mt.svg'


const _hoisted_1 = { class: "row landing-header justify-between items-center q-mt-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "q-mr-sm"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-text" }, "Masons Partners", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "column justify-center items-center q-mb-xl" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white" }, "FAQ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_center = _resolveComponent("center")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, { class: "main-container q-layout-container" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "row items-center cursor-pointer masons-logo",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "q-pa-md",
              style: _normalizeStyle(
            _ctx.$q.screen.width > 1000 ? 'width: 1000 !important;' : 'width: 400px'
          )
            }, [
              _createVNode(_component_q_list, { style: {"border":"1px solid #66635f"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Что такое партнерская программа Masons.Partners?",
                    "default-opened": "",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Masons.Partners - международная партнерская программа, которая работает с гемблинг офферами. После регистрации партнеры получают возможность монетизировать свой трафик на лучших условиях. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Трафик из каких стран принимаете?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" В настоящее время доступные офферы из СНГ, Европы и Латинской Америки. Список стран постоянно пополняется. Актуальную информацию всегда можно уточнить у личного менеджера. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Какие источники трафика запрещены?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Запрещенные виды трафика и накрутки не оплачиваются ПП Masons.Partners. Мы не принимаем любые виды СПАМА, исключаем ФРОД и ограничиваем брендовые виды трафика. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Есть ли реферальная программа?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Реферальная программа - это дополнительный способ заработка для вебмастера, основанный на рекомендации ПП Masons.Partners друзьям и партнерам. На данный момент нет, однако мы готовы обсудить реферальную систему в индивидуальном порядке. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Какие модели оплаты принимает ПП Masons.Partners?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" В зависимости от оффера и ГЕО мы готовы предложить две самых популярных системы оплаты партнерского трафика: СРА (cost per action) - оплата за целевое действие пользователя на сайте. RevShare - оплата происходит, исходя от % с прибыли, которая генерируется приведенными игроками. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Есть ли ограничения по выплатам?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Для получения выплаты необходимо иметь на личном счете сумму более 50$ или ее эквивалент и выбрать один из удобных способов вывода средств. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator, { style: {"background":"#65635f"} }),
                  _createVNode(_component_q_expansion_item, {
                    class: "faq-expand-item",
                    icon: "explore",
                    label: "Где можно получить бесплатные крео и приложения?",
                    "header-class": "text-primary text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { style: {"font-size":"18px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Достаточно просто написать личному менеджеру, который не только предоставит бесплатные крео и приложения, а посоветует лучший оффер и ГЕО, но и окажет постоянную поддержку от запуска до вывода средств. ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 4),
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "chevron_left",
                  flat: "",
                  "text-color": "white",
                  label: "Главная",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}